// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { axios } from './utils/axiosTool'
import {getUrlQuery} from './utils/fristJump'
import 'babel-polyfill'
import VueQriously from 'vue-qriously';
//引入vuex

import store from './store'
//引入websocket
import * as socketApi from './utils/websocket'
Vue.prototype.socketApi = socketApi
import './utils/upload'
//引入字体
import './assets/css/iconfont/iconfont.css'

import '../static/css/reset.css'
import '../static/css/qqface.css'

import Toast from '@/components/toast'
import MessagePopup from '@/components/MessagePopup'
import authentication from './authentication'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(VueQriously);
Vue.use(Toast);
Vue.use(MessagePopup);
Vue.use(ElementUI);
Vue.config.productionTip = false

//引入过滤器
import * as filters from './utils/filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
//
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,//使用store
  router,
  render: h => h(App),
  methods:{
    getwxids(){
      console.log(22)
    }
  }
})

export default Vue




// WEBPACK FOOTER //
// ./src/main.js